import React from 'react';
import { Box, Stack } from '@mui/material';
import { fmtNumber } from '../utils';

interface IStatPillProps {
  total: number;
  learned: number;
  due: number;
}

const Item: React.FC<{ n: number; label: string }> = ({ n, label }) => (
  <Box
    component={'span'}
    sx={{ color: 'text.secondary', fontSize: 15, whiteSpace: 'nowrap' }}
  >
    <Box
      component={'b'}
      sx={{
        color: 'primary.main',
        fontSize: 20,
        fontWeight: 800,
        mr: 0.75,
      }}
    >
      {fmtNumber(n)}
    </Box>
    {label}
  </Box>
);

const StatPill: React.FC<IStatPillProps> = ({ total, learned, due }) => {
  const items: Array<[number, string]> = [
    [total, 'слів'],
    [learned, 'вивчено'],
    [due, 'на повторення'],
  ];

  return (
    <Stack
      direction={'row'}
      spacing={3.25}
      divider={
        <Box
          sx={{
            alignSelf: 'center',
            bgcolor: 'divider',
            height: 22,
            width: '1px',
          }}
        />
      }
    >
      {items.map(([n, label]) => (
        <Item key={label} n={n} label={label} />
      ))}
    </Stack>
  );
};

export default StatPill;
